<template>
  <div class="invitation-card">
    <img
      alt=""
      class="btn"
      data-clipboard-action="copy"
      data-clipboard-text="flkf17001"
      src="@/assets/imgs/invitation-card/button.png"
      @click="copy"
    />
  </div>
</template>

<script>
import Clipboard from "clipboard";

export default {
  name: "InvitationCard",
  methods: {
    /** 点击复制 */
    copy() {
      let clipboard = new Clipboard(".btn");
      clipboard.on("success", () => {
        this.$toast("复制成功");
      });

      clipboard.on("error", (e) => {
        console.log(e);
      });
    },
  },
};
</script>

<style lang="scss">
@media screen and (min-width: 750px) {
  html {
    font-size: 117.1px !important; // 这里加权重是因为 amfe-flexible 通过行内样式设置了根字体
  }

  body {
    max-width: 500px; // 顺带提下，这里也可以小写 px，大写 PX 可以让 postcss-pxtorem 忽略转成 rem
    margin: 0 auto;
  }
}
</style>

<style lang="scss" scoped>
.invitation-card {
  width: 375px;
  height: 713px;
  background: url(../../assets/imgs/invitation-card/background.jpg);
  background-size: 100% 100%;
  position: relative;
}

.btn {
  width: 120px;
  height: 32px;
  position: absolute;
  right: 45px;
  bottom: 187px;
}
</style>
